// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../../../reason/next/Next.bs.js");
let React = require("react");
let FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
let Numeral = require("../../../utils/Numeral.bs.js");
let Spinner = require("../../../uikit/reason/atoms/Spinner/Spinner.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let ViewStack = require("../../../reason/common/ViewStack.bs.js");
let FeaturesV3 = require("../../../reason/featureFlipper/FeaturesV3.bs.js");
let Responsive = require("../../../uikit/reason/helpers/Responsive.bs.js");
let Stdlib_Int = require("@rescript/runtime/lib/js/Stdlib_Int.js");
let Form__Input = require("../../../uikit/reason/atoms/Form/Form__Input.bs.js");
let Form__Label = require("../../../uikit/reason/atoms/Form/Form__Label.bs.js");
let Form__Radio = require("../../../uikit/reason/atoms/Form/Form__Radio.bs.js");
let FormalityUI = require("../../common/Form/FormalityUI.bs.js");
let PageUITitle = require("../../../components/PageTitle/PageUITitle.bs.js");
let UserSession = require("../../../reason/common/UserSession/UserSession.bs.js");
let FocusTracker = require("../../common/Form/FocusTracker.bs.js");
let LotSizeInput = require("./components/LotSizeInput.bs.js");
let Stdlib_Float = require("@rescript/runtime/lib/js/Stdlib_Float.js");
let Form__Helpers = require("../../../reason/common/Form/Form__Helpers.bs.js");
let Heading__Jsx3 = require("../../../uikit/reason/helpers/Heading__Jsx3.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Stdlib_Result = require("@rescript/runtime/lib/js/Stdlib_Result.js");
let Form__Checkbox = require("../../../uikit/reason/atoms/Form/Form__Checkbox.bs.js");
let GeocodingError = require("./Geocoding/GeocodingError.bs.js");
let GeocodingQuery = require("./Geocoding/GeocodingQuery.bs.js");
let SystemMessages = require("../../../reason/systemMessages/SystemMessages.bs.js");
let Form__HelpLabel = require("../../../uikit/reason/atoms/Form/Form__HelpLabel.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RichTextEditorV5 = require("../../common/Components/RichTextEditorV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertyPriceInput = require("./PropertyPriceInput.bs.js");
let PropertyTypeSelect = require("./components/PropertyTypeSelect.bs.js");
let MobileInputTextSize = require("../../common/Form/MobileInputTextSize.bs.js");
let PropertyParkingInfo = require("../../common/Property/PropertyParkingInfo.bs.js");
let AttachmentFormSection = require("../../common/attachments/AttachmentFormSection.bs.js");
let CityZipAutocompleteV5 = require("./CityZipAutocompleteV5.bs.js");
let QuietPropertyTipBoxes = require("./components/QuietPropertyTipBoxes.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");
let CreateQuietSellerFormConfig = require("./CreateQuietSellerFormConfig.bs.js");
let ForSalePropertyAttributesInput = require("./ForSalePropertyAttributesInput.bs.js");
let CreateQuietSellerFormMutation_graphql = require("../../../__generated__/CreateQuietSellerFormMutation_graphql.bs.js");
let PropertyAddressValidationDuplicatePropertyError = require("./Geocoding/PropertyAddressValidationDuplicatePropertyError.bs.js");

function messageToString(v) {
  if (typeof v !== "object") {
    if (v === "IsRequired") {
      return "is required";
    } else if (v === "InvalidEmailAddress") {
      return "must be a valid email address";
    } else {
      return "must be greater than the lower price";
    }
  }
  let variant = v.NAME;
  if (variant === "PriceMustBeGeq") {
    return `must be ` + Numeral.formatPrice(v.VAL) + ` or greater`;
  } else if (variant === "PriceMustBeLeq") {
    return `must be ` + Numeral.formatPrice(v.VAL) + ` or less`;
  } else if (variant === "AttachmentsError") {
    return v.VAL;
  } else {
    return "Geocoding error";
  }
}

function CreateQuietSellerForm$FieldValidationMessage(props) {
  return JsxRuntime.jsx(FormalityUI.FieldValidationMessage.make, {
    messageToString: messageToString,
    result: props.result
  });
}

let FieldValidationMessage = {
  make: CreateQuietSellerForm$FieldValidationMessage
};

let FocusTracker$1 = FocusTracker.Make({});

function CreateQuietSellerForm$Location$LoadingSpinner(props) {
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(Spinner.make, {}),
    className: "absolute right-[8px] bottom-[8px] h-[21px] w-[21px] flex items-center justify-center"
  });
}

let LoadingSpinner = {
  make: CreateQuietSellerForm$Location$LoadingSpinner
};

function CreateQuietSellerForm$Location(props) {
  let focusTracker = props.focusTracker;
  let form = props.form;
  let match = form.addressResult;
  let match$1 = form.locationResult;
  let tmp;
  tmp = match !== undefined ? (
      match.TAG === "Ok" ? (
          match$1 !== undefined && match$1.TAG !== "Validating" ? (
              match$1._0.TAG === "Ok" ? "ok" : "error"
            ) : undefined
        ) : "error"
    ) : undefined;
  let match$2 = form.locationResult;
  let tmp$1;
  tmp$1 = match$2 !== undefined && match$2.TAG === "Validating" ? JsxRuntime.jsx(CreateQuietSellerForm$Location$LoadingSpinner, {}) : null;
  let match$3 = form.areaResult;
  let match$4 = form.locationResult;
  let tmp$2;
  tmp$2 = match$3 !== undefined ? (
      match$3.TAG === "Ok" ? (
          match$4 !== undefined && match$4.TAG !== "Validating" ? (
              match$4._0.TAG === "Ok" ? "ok" : "error"
            ) : undefined
        ) : "error"
    ) : undefined;
  let match$5 = form.locationResult;
  let tmp$3;
  if (match$5 !== undefined && match$5.TAG !== "Validating") {
    let match$6 = match$5._0;
    if (match$6.TAG === "Ok") {
      tmp$3 = null;
    } else {
      let match$7 = match$6._0;
      if (typeof match$7 === "object") {
        let variant = match$7.NAME;
        tmp$3 = variant === "DuplicatePropertyError" ? JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
            width: 12,
            children: JsxRuntime.jsx(PropertyAddressValidationDuplicatePropertyError.make, {
              property: match$7.VAL.fragmentRefs
            })
          }) : (
            variant === "GeocodingError" ? JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
                width: 12,
                children: JsxRuntime.jsx(GeocodingError.make, {
                  reason: match$7.VAL
                })
              }) : null
          );
      } else {
        tmp$3 = null;
      }
    }
  } else {
    tmp$3 = null;
  }
  return JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Grid.make, {
    children: [
      JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: 12,
        widthMd: 6,
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Form__Input.make, {
                labelText: "Street address",
                onChange: event => {
                  let value = event.target.value;
                  form.updateAddress((input, value) => {
                    let newrecord = {...input};
                    newrecord.address = value;
                    return newrecord;
                  }, value);
                },
                onBlur: param => {
                  focusTracker.clearFocus();
                  form.blurAddress();
                },
                onFocus: param => focusTracker.focus("Address"),
                status: tmp,
                value: form.input.address
              }),
              tmp$1
            ],
            className: "relative"
          }),
          JsxRuntime.jsx(CreateQuietSellerForm$FieldValidationMessage, {
            result: form.addressResult
          }),
          JsxRuntime.jsx(ViewStack.make, {
            mt: "sm"
          }),
          JsxRuntime.jsx(Form__HelpLabel.make, {
            children: "Not shared with anyone, only used for matching."
          })
        ]
      }),
      JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: 12,
        widthMd: 6,
        children: [
          JsxRuntime.jsx(Form__Label.make, {
            labelText: "City or Zip"
          }),
          JsxRuntime.jsx(CityZipAutocompleteV5.make, {
            value: Primitive_option.some(form.input.area),
            onChange: area => form.updateArea((input, value) => {
              let newrecord = {...input};
              newrecord.area = value;
              return newrecord;
            }, area),
            onBlur: param => {
              focusTracker.clearFocus();
              form.blurArea();
            },
            onFocus: param => focusTracker.focus("Address"),
            status: tmp$2
          }),
          JsxRuntime.jsx(CreateQuietSellerForm$FieldValidationMessage, {
            result: form.areaResult
          })
        ]
      }),
      tmp$3
    ]
  });
}

let Location = {
  LoadingSpinner: LoadingSpinner,
  make: CreateQuietSellerForm$Location
};

function CreateQuietSellerForm$Price(props) {
  let focusTracker = props.focusTracker;
  let form = props.form;
  let match = form.input.priceType;
  return JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Grid.make, {
    children: [
      match === "ExactPrice" ? JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
          width: 12,
          widthMd: 4,
          children: [
            JsxRuntime.jsx(Form__Input.make, {
              labelText: "Price",
              onChange: event => {
                let value = Form__Helpers.intFromFormattedPrice(event);
                form.updatePrice((input, value) => {
                  let newrecord = {...input};
                  newrecord.price = value;
                  return newrecord;
                }, value);
              },
              onBlur: param => form.blurPrice(),
              status: FormalityUI.UIKitStatus.ofOptFieldResult(form.priceResult),
              prepend: "$",
              value: Form__Helpers.intOptToFormattedPrice(form.input.price)
            }),
            JsxRuntime.jsx(CreateQuietSellerForm$FieldValidationMessage, {
              result: form.priceResult
            })
          ]
        }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
              width: 12,
              widthMd: 4,
              children: [
                JsxRuntime.jsx(Form__Input.make, {
                  labelText: "Lower Price",
                  onChange: event => {
                    let value = Form__Helpers.intFromFormattedPrice(event);
                    form.updateMinPrice((input, value) => {
                      let newrecord = {...input};
                      newrecord.minPrice = value;
                      return newrecord;
                    }, value);
                  },
                  onBlur: param => {
                    focusTracker.clearFocus();
                    form.blurMinPrice();
                  },
                  onFocus: param => focusTracker.focus("PriceRange"),
                  status: FormalityUI.UIKitStatus.ofOptFieldResult(form.minPriceResult),
                  prepend: "$",
                  value: Form__Helpers.intOptToFormattedPrice(form.input.minPrice)
                }),
                JsxRuntime.jsx(CreateQuietSellerForm$FieldValidationMessage, {
                  result: form.minPriceResult
                })
              ]
            }),
            JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
              width: 12,
              widthMd: 4,
              children: [
                JsxRuntime.jsx(Form__Input.make, {
                  labelText: "Upper Price",
                  onChange: event => {
                    let value = Form__Helpers.intFromFormattedPrice(event);
                    form.updateMaxPrice((input, value) => {
                      let newrecord = {...input};
                      newrecord.maxPrice = value;
                      return newrecord;
                    }, value);
                  },
                  onBlur: param => {
                    focusTracker.clearFocus();
                    form.blurMaxPrice();
                  },
                  onFocus: param => focusTracker.focus("PriceRange"),
                  status: FormalityUI.UIKitStatus.ofOptFieldResult(form.maxPriceResult),
                  prepend: "$",
                  value: Form__Helpers.intOptToFormattedPrice(form.input.maxPrice)
                }),
                JsxRuntime.jsx(CreateQuietSellerForm$FieldValidationMessage, {
                  result: form.maxPriceResult
                })
              ]
            })
          ]
        }),
      JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: 12,
        children: JsxRuntime.jsx(Form__Checkbox.make, {
          onChange: param => {
            let match = form.input.priceType;
            let newValue = match === "ExactPrice" ? "PriceRange" : "ExactPrice";
            form.updatePriceType((input, priceType) => {
              let newrecord = {...input};
              newrecord.priceType = priceType;
              return newrecord;
            }, newValue);
          },
          checked: form.input.priceType === "PriceRange",
          label: "Or enter a price range instead"
        })
      })
    ]
  });
}

let Price = {
  make: CreateQuietSellerForm$Price
};

function CreateQuietSellerForm$PropertyAttributes$SingleFamilyAndCondoAttributes(props) {
  let form = props.form;
  let parkingInfoEnabled = FeaturesV3.usePropertyParkingInfoEnabled();
  let isCondo = form.input.propertyType === "Condo";
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: 6,
        widthMd: 3,
        children: [
          JsxRuntime.jsx(Form__Input.make, {
            labelText: "Beds",
            onChange: evt => {
              let value = Stdlib_Int.fromString(Form__Helpers.stripNonDigits(evt.target.value), undefined);
              form.updateBeds((input, beds) => {
                let newrecord = {...input};
                newrecord.beds = beds;
                return newrecord;
              }, value);
            },
            onBlur: param => form.blurBeds(),
            status: FormalityUI.UIKitStatus.ofOptFieldResult(form.bedsResult),
            value: Stdlib_Option.mapOr(form.input.beds, "", v => v.toString())
          }),
          JsxRuntime.jsx(CreateQuietSellerForm$FieldValidationMessage, {
            result: form.bedsResult
          })
        ]
      }),
      JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: 6,
        widthMd: 3,
        children: [
          JsxRuntime.jsx(Form__Input.make, {
            labelText: "Baths",
            onChange: evt => {
              let value = Stdlib_Float.fromString(Form__Helpers.stripNonDigits(evt.target.value));
              form.updateBaths((input, baths) => {
                let newrecord = {...input};
                newrecord.baths = baths;
                return newrecord;
              }, value);
            },
            onBlur: param => form.blurBaths(),
            status: FormalityUI.UIKitStatus.ofOptFieldResult(form.bathsResult),
            value: Stdlib_Option.mapOr(form.input.baths, "", v => v.toString())
          }),
          JsxRuntime.jsx(CreateQuietSellerForm$FieldValidationMessage, {
            result: form.bathsResult
          })
        ]
      }),
      JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: 6,
        widthMd: 3,
        children: JsxRuntime.jsx(Form__Input.make, {
          labelText: "Half-Baths",
          optionalText: "optional",
          onChange: evt => {
            let value = Stdlib_Int.fromString(Form__Helpers.stripNonDigits(evt.target.value), undefined);
            form.updateBeds((input, halfBaths) => {
              let newrecord = {...input};
              newrecord.halfBaths = halfBaths;
              return newrecord;
            }, value);
          },
          onBlur: param => form.blurHalfBaths(),
          status: FormalityUI.UIKitStatus.ofOptFieldResult(form.halfBathsResult),
          value: Stdlib_Option.mapOr(form.input.halfBaths, "", v => v.toString())
        })
      }),
      JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: 6,
        widthMd: 3,
        children: JsxRuntime.jsx(Form__Input.make, {
          labelText: "Living Area",
          optionalText: "optional",
          onChange: evt => {
            let value = Form__Helpers.intFromFormattedNumberString(evt.target.value);
            form.updateLivingArea((input, livingArea) => {
              let newrecord = {...input};
              newrecord.livingArea = livingArea;
              return newrecord;
            }, value);
          },
          onBlur: param => form.blurLivingArea(),
          status: FormalityUI.UIKitStatus.ofOptFieldResult(form.livingAreaResult),
          append: "sqft",
          value: Stdlib_Option.mapOr(form.input.livingArea, "", Numeral.formatNumber)
        })
      }),
      JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: 12,
        widthMd: 6,
        children: JsxRuntime.jsx(LotSizeInput.make, {
          value: form.input.lotSize,
          lotSizeUnit: form.input.lotSizeUnit,
          onChange: value => form.updateLotSize((input, lotSize) => {
            let newrecord = {...input};
            newrecord.lotSize = lotSize;
            return newrecord;
          }, value),
          onBlur: () => form.blurLotSize(),
          onUnitChange: lotSizeUnit => form.updateLotSizeUnit((input, lotSizeUnit) => {
            let newrecord = {...input};
            newrecord.lotSizeUnit = lotSizeUnit;
            return newrecord;
          }, lotSizeUnit),
          onUnitBlur: () => form.blurLotSizeUnit(),
          status: FormalityUI.UIKitStatus.ofOptFieldResult(form.lotSizeResult),
          optionalText: "optional"
        })
      }),
      parkingInfoEnabled && isCondo ? JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
          width: 12,
          className: "mt-5",
          children: JsxRuntime.jsx(PropertyParkingInfo.InputFields.make, {
            parkingSpaces: form.input.parkingSpaces,
            parkingDetails: form.input.parkingDetails,
            onParkingSpacesChange: value => form.updateParkingSpaces((input, parkingSpaces) => {
              let newrecord = {...input};
              newrecord.parkingSpaces = parkingSpaces;
              return newrecord;
            }, value),
            onParkingSpacesBlur: form.blurParkingSpaces,
            onParkingDetailsChange: value => form.updateParkingDetails((input, parkingDetails) => {
              let newrecord = {...input};
              newrecord.parkingDetails = parkingDetails;
              return newrecord;
            }, value),
            onParkingDetailsBlur: form.blurParkingDetails
          })
        }) : null
    ]
  });
}

let SingleFamilyAndCondoAttributes = {
  make: CreateQuietSellerForm$PropertyAttributes$SingleFamilyAndCondoAttributes
};

function CreateQuietSellerForm$PropertyAttributes$MultiUnitAttributes(props) {
  let form = props.form;
  return JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
    width: 6,
    widthMd: 4,
    children: [
      JsxRuntime.jsx(Form__Input.make, {
        labelText: "Number of Units",
        onChange: evt => {
          let value = Stdlib_Int.fromString(Form__Helpers.stripNonDigits(evt.target.value), undefined);
          form.updateNumberOfUnits((input, numberOfUnits) => {
            let newrecord = {...input};
            newrecord.numberOfUnits = numberOfUnits;
            return newrecord;
          }, value);
        },
        onBlur: param => form.blurNumberOfUnits(),
        status: FormalityUI.UIKitStatus.ofOptFieldResult(form.numberOfUnitsResult),
        value: Stdlib_Option.mapOr(form.input.numberOfUnits, "", v => v.toString())
      }),
      JsxRuntime.jsx(CreateQuietSellerForm$FieldValidationMessage, {
        result: form.numberOfUnitsResult
      })
    ]
  });
}

let MultiUnitAttributes = {
  make: CreateQuietSellerForm$PropertyAttributes$MultiUnitAttributes
};

function CreateQuietSellerForm$PropertyAttributes$LotAttributes(props) {
  let form = props.form;
  return JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
    width: 12,
    widthMd: 6,
    children: [
      JsxRuntime.jsx(LotSizeInput.make, {
        value: form.input.lotSize,
        lotSizeUnit: form.input.lotSizeUnit,
        onChange: value => form.updateLotSize((input, lotSize) => {
          let newrecord = {...input};
          newrecord.lotSize = lotSize;
          return newrecord;
        }, value),
        onBlur: () => form.blurLotSize(),
        onUnitChange: lotSizeUnit => form.updateLotSizeUnit((input, lotSizeUnit) => {
          let newrecord = {...input};
          newrecord.lotSizeUnit = lotSizeUnit;
          return newrecord;
        }, lotSizeUnit),
        onUnitBlur: () => form.blurLotSizeUnit(),
        status: FormalityUI.UIKitStatus.ofOptFieldResult(form.lotSizeResult)
      }),
      JsxRuntime.jsx(CreateQuietSellerForm$FieldValidationMessage, {
        result: form.lotSizeResult
      })
    ]
  });
}

let LotAttributes = {
  make: CreateQuietSellerForm$PropertyAttributes$LotAttributes
};

let options = [
  "SingleFamily",
  "Condo",
  "Lot",
  "MultiUnit"
].map(PropertyTypeSelect.PropertyTypeOption.make);

function CreateQuietSellerForm$PropertyAttributes$ForSalePropertyTypeSelect(props) {
  let result = props.result;
  let onChange = props.onChange;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: "Property Type"
      }),
      JsxRuntime.jsx(PropertyTypeSelect.make, {
        value: props.value,
        options: options,
        onChange: v => {
          if (onChange !== undefined) {
            return onChange(v);
          }
        },
        onFocus: props.onFocus,
        onBlur: props.onBlur,
        status: FormalityUI.UIKitStatus.ofOptFieldResult(result)
      }),
      JsxRuntime.jsx(CreateQuietSellerForm$FieldValidationMessage, {
        result: result
      })
    ]
  });
}

let ForSalePropertyTypeSelect = {
  options: options,
  make: CreateQuietSellerForm$PropertyAttributes$ForSalePropertyTypeSelect
};

function CreateQuietSellerForm$PropertyAttributes(props) {
  let form = props.form;
  let match = form.input.propertyType;
  return JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Grid.make, {
    children: [
      JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: 12,
        widthMd: 4,
        children: JsxRuntime.jsx(CreateQuietSellerForm$PropertyAttributes$ForSalePropertyTypeSelect, {
          value: form.input.propertyType,
          onChange: v => form.updatePropertyType((input, propertyType) => {
            let newrecord = {...input};
            newrecord.propertyType = propertyType;
            return newrecord;
          }, v),
          result: form.propertyTypeResult
        })
      }),
      match !== undefined ? (
          match === "Lot" ? JsxRuntime.jsx(CreateQuietSellerForm$PropertyAttributes$LotAttributes, {
              form: form
            }) : (
              match === "MultiUnit" ? JsxRuntime.jsx(CreateQuietSellerForm$PropertyAttributes$MultiUnitAttributes, {
                  form: form
                }) : JsxRuntime.jsx(CreateQuietSellerForm$PropertyAttributes$SingleFamilyAndCondoAttributes, {
                  form: form
                })
            )
        ) : null
    ]
  });
}

let PropertyAttributes = {
  SingleFamilyAndCondoAttributes: SingleFamilyAndCondoAttributes,
  MultiUnitAttributes: MultiUnitAttributes,
  LotAttributes: LotAttributes,
  ForSalePropertyTypeSelect: ForSalePropertyTypeSelect,
  make: CreateQuietSellerForm$PropertyAttributes
};

function CreateQuietSellerForm$Privacy(props) {
  let form = props.form;
  let userHasHiddenPropertyFeatures = UserSession.useHasPlanFeature("HIDE_PROPERTY");
  let anonymousMatchingEnabled = UserSession.useChapterPreference("AnonymousMatching") === "ON";
  return JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Grid.make, {
    children: JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
      width: 12,
      children: [
        JsxRuntime.jsx(Heading__Jsx3.make, {
          as_: "h3",
          children: "Privacy"
        }),
        JsxRuntime.jsxs(ViewStack.make, {
          space: {
            NAME: "px",
            VAL: "p20"
          },
          children: [
            JsxRuntime.jsx("p", {
              children: "What information do you want to share with matching buyer agents? "
            }),
            JsxRuntime.jsx(Form__Radio.RadioCardList.make, {
              selected: form.input.privacy,
              items: [
                {
                  title: "Share the property and my identity",
                  description: "The buyer agents that match will see the property information (except the street address) and your identity.",
                  value: "Normal"
                },
                {
                  title: "Hide my name",
                  description: "The buyer agents won't know who you are, but will see the property information (except the street address) and can request information from you. You can choose to share your identity on conversations.",
                  value: "HideMyName",
                  skip: !anonymousMatchingEnabled
                },
                {
                  title: "Hide the property completely",
                  description: "Only you will see the matches. Buyer agents won't see your property at all.",
                  disabled: !userHasHiddenPropertyFeatures,
                  overlay: userHasHiddenPropertyFeatures ? undefined : "pro only",
                  value: "HideProperty"
                }
              ],
              name: "privacy",
              toValue: v => v,
              onChange: s => form.updatePrivacy((input, privacy) => {
                let newrecord = {...input};
                newrecord.privacy = privacy;
                return newrecord;
              }, s)
            })
          ]
        })
      ]
    })
  });
}

let Privacy = {
  make: CreateQuietSellerForm$Privacy
};

function CreateQuietSellerForm$Description(props) {
  let form = props.form;
  let initialDescription = React.useRef(form.input.description);
  return JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Grid.make, {
    children: JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
      width: 12,
      children: [
        JsxRuntime.jsx(Heading__Jsx3.make, {
          as_: "h3",
          children: "Description"
        }),
        JsxRuntime.jsxs(ViewStack.make, {
          space: {
            NAME: "px",
            VAL: "p20"
          },
          children: [
            JsxRuntime.jsx("p", {
              children: "What should TAN agents know about your seller?"
            }),
            JsxRuntime.jsx(RichTextEditorV5.make, {
              initialContent: initialDescription.current,
              onChange: value => form.updateDescription((input, value) => {
                let newrecord = {...input};
                newrecord.description = value;
                return newrecord;
              }, value),
              onBlur: param => form.blurDescription(),
              toolbar: "none",
              height: "short",
              status: FormalityUI.UIKitStatus.ofOptFieldResult(form.descriptionResult),
              placeholderText: "For example: great view, $300k in upgrades, seller can't move until September, home shows poorly, etc."
            })
          ]
        }),
        JsxRuntime.jsx(CreateQuietSellerForm$FieldValidationMessage, {
          result: form.descriptionResult
        })
      ]
    })
  });
}

let Description = {
  make: CreateQuietSellerForm$Description
};

function CreateQuietSellerForm$Client(props) {
  let form = props.form;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsxs(Heading__Jsx3.make, {
        children: [
          "Your client information ",
          JsxRuntime.jsx("span", {
            children: "(Only you can see it)",
            className: "text-zinc-500"
          })
        ]
      }),
      JsxRuntime.jsxs(ViewStack.make, {
        space: {
          NAME: "px",
          VAL: "p20"
        },
        children: [
          JsxRuntime.jsxs("p", {
            children: [
              "This information is ",
              JsxRuntime.jsx("strong", {
                children: "private and only visible to you"
              }),
              ". By adding your client's name and email below you'll be able to\n      quickly send them information on matching buyers with just one click. "
            ]
          }),
          JsxRuntime.jsxs(ViewStack.make, {
            children: [
              JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Grid.make, {
                children: JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
                  width: 12,
                  widthMd: 4,
                  children: [
                    JsxRuntime.jsx(Form__Input.make, {
                      labelText: "First Name",
                      onChange: event => {
                        let value = event.target.value;
                        form.updateFirstName((input, value) => {
                          let newrecord = {...input};
                          newrecord.firstName = value;
                          return newrecord;
                        }, value);
                      },
                      onBlur: param => form.blurFirstName(),
                      status: FormalityUI.UIKitStatus.ofOptFieldResult(form.firstNameResult),
                      value: form.input.firstName
                    }),
                    JsxRuntime.jsx(CreateQuietSellerForm$FieldValidationMessage, {
                      result: form.firstNameResult
                    })
                  ]
                })
              }),
              JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Grid.make, {
                children: JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
                  width: 12,
                  widthMd: 4,
                  children: [
                    JsxRuntime.jsx(Form__Input.make, {
                      labelText: "Last Name",
                      optionalText: "optional",
                      onChange: event => {
                        let value = event.target.value;
                        form.updateLastName((input, value) => {
                          let newrecord = {...input};
                          newrecord.lastName = value;
                          return newrecord;
                        }, value);
                      },
                      onBlur: param => form.blurLastName(),
                      status: FormalityUI.UIKitStatus.ofOptFieldResult(form.lastNameResult),
                      value: form.input.lastName
                    }),
                    JsxRuntime.jsx(CreateQuietSellerForm$FieldValidationMessage, {
                      result: form.lastNameResult
                    })
                  ]
                })
              }),
              JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Grid.make, {
                children: JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
                  width: 12,
                  widthMd: 4,
                  children: [
                    JsxRuntime.jsx(Form__Input.make, {
                      labelText: "Email",
                      optionalText: "optional",
                      onChange: event => {
                        let value = event.target.value;
                        form.updateEmailAddress((input, value) => {
                          let newrecord = {...input};
                          newrecord.emailAddress = value;
                          return newrecord;
                        }, value);
                      },
                      onBlur: param => form.blurEmailAddress(),
                      status: FormalityUI.UIKitStatus.ofOptFieldResult(form.emailAddressResult),
                      value: form.input.emailAddress
                    }),
                    JsxRuntime.jsx(CreateQuietSellerForm$FieldValidationMessage, {
                      result: form.emailAddressResult
                    })
                  ]
                })
              })
            ]
          })
        ]
      })
    ]
  });
}

let Client = {
  make: CreateQuietSellerForm$Client
};

function CreateQuietSellerForm$AttachmentSection(props) {
  let form = props.form;
  let match = form.imagesResult;
  let tmp;
  if (match !== undefined) {
    if (match.TAG === "Ok") {
      tmp = {
        TAG: "Ok",
        _0: match._0
      };
    } else {
      let match$1 = match._0;
      tmp = typeof match$1 === "object" && match$1.NAME === "AttachmentsError" ? ({
          TAG: "Error",
          _0: match$1.VAL
        }) : undefined;
    }
  } else {
    tmp = undefined;
  }
  let match$2 = form.filesResult;
  let tmp$1;
  if (match$2 !== undefined) {
    if (match$2.TAG === "Ok") {
      tmp$1 = {
        TAG: "Ok",
        _0: match$2._0
      };
    } else {
      let match$3 = match$2._0;
      tmp$1 = typeof match$3 === "object" && match$3.NAME === "AttachmentsError" ? ({
          TAG: "Error",
          _0: match$3.VAL
        }) : undefined;
    }
  } else {
    tmp$1 = undefined;
  }
  return JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Grid.make, {
    children: JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
      width: 12,
      children: [
        JsxRuntime.jsx(Heading__Jsx3.make, {
          as_: "h3",
          children: "Photos and files"
        }),
        JsxRuntime.jsx(ViewStack.make, {
          space: {
            NAME: "px",
            VAL: "p20"
          },
          children: JsxRuntime.jsx(AttachmentFormSection.make, {
            images: form.input.images,
            files: form.input.files,
            imagesResult: tmp,
            filesResult: tmp$1,
            updateImages: v => form.updateImages((state, attachments) => {
              let newrecord = {...state};
              newrecord.images = attachments;
              return newrecord;
            }, v),
            updateFiles: v => form.updateFiles((state, attachments) => {
              let newrecord = {...state};
              newrecord.files = attachments;
              return newrecord;
            }, v)
          })
        })
      ]
    })
  });
}

let AttachmentSection = {
  make: CreateQuietSellerForm$AttachmentSection
};

let initialInput_images = [];

let initialInput_files = [];

let initialInput = {
  address: "",
  area: undefined,
  location: undefined,
  priceType: "ExactPrice",
  price: undefined,
  minPrice: undefined,
  maxPrice: undefined,
  propertyType: undefined,
  beds: undefined,
  baths: undefined,
  halfBaths: undefined,
  livingArea: undefined,
  lotSize: undefined,
  lotSizeUnit: "SQ_FT",
  numberOfUnits: undefined,
  parkingSpaces: undefined,
  parkingDetails: undefined,
  privacy: "Normal",
  description: undefined,
  firstName: "",
  lastName: "",
  emailAddress: "",
  images: initialInput_images,
  files: initialInput_files
};

let convertVariables = CreateQuietSellerFormMutation_graphql.Internal.convertVariables;

let convertResponse = CreateQuietSellerFormMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = CreateQuietSellerFormMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, CreateQuietSellerFormMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, CreateQuietSellerFormMutation_graphql.node, convertResponse, convertWrapRawResponse);

let Mutation_lotSizeUnit_decode = CreateQuietSellerFormMutation_graphql.Utils.lotSizeUnit_decode;

let Mutation_lotSizeUnit_fromString = CreateQuietSellerFormMutation_graphql.Utils.lotSizeUnit_fromString;

let Mutation_quietPropertyPrivacy_decode = CreateQuietSellerFormMutation_graphql.Utils.quietPropertyPrivacy_decode;

let Mutation_quietPropertyPrivacy_fromString = CreateQuietSellerFormMutation_graphql.Utils.quietPropertyPrivacy_fromString;

let Mutation = {
  lotSizeUnit_decode: Mutation_lotSizeUnit_decode,
  lotSizeUnit_fromString: Mutation_lotSizeUnit_fromString,
  quietPropertyPrivacy_decode: Mutation_quietPropertyPrivacy_decode,
  quietPropertyPrivacy_fromString: Mutation_quietPropertyPrivacy_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function CreateQuietSellerForm(props) {
  let router = Next.useRouter();
  let match = SystemMessages.useSystemMessages();
  let addMessage = match.addMessage;
  let match$1 = use();
  let mutate = match$1[0];
  let form = CreateQuietSellerFormConfig.useForm(initialInput, {
    geocodingQueryFn: (none, none$1) => GeocodingQuery.queryFn(none, none$1, "SELLER", undefined)
  }, (param, param$1) => {
    let notifyOnFailure = param$1.notifyOnFailure;
    let notifyOnSuccess = param$1.notifyOnSuccess;
    let lastName = param.lastName;
    let location = param.location;
    let handleError = () => {
      notifyOnFailure();
      addMessage(SystemMessages.Message.make(undefined, "error", "There was an error adding your Quiet Seller. Please try again", 5000, undefined, undefined));
    };
    let attributes = Stdlib_Result.getOrThrow(ForSalePropertyAttributesInput.make(param.propertyType, param.beds, param.baths, param.halfBaths, param.lotSize, param.lotSizeUnit, param.livingArea, param.numberOfUnits, param.parkingSpaces, param.parkingDetails), undefined);
    let price = Stdlib_Result.getOrThrow(PropertyPriceInput.make(param.priceType, param.price, param.minPrice, param.maxPrice), undefined);
    let tmp = lastName === "" ? undefined : lastName;
    let tmp$1;
    switch (param.privacy) {
      case "Normal" :
        tmp$1 = "NORMAL";
        break;
      case "HideMyName" :
        tmp$1 = "ANONYMOUS";
        break;
      case "HideProperty" :
        tmp$1 = "HIDDEN";
        break;
    }
    mutate({
      input: {
        attributes: attributes,
        contact: {
          email: param.emailAddress,
          firstName: param.firstName,
          lastName: tmp
        },
        description: param.description,
        files: param.files,
        images: param.images,
        location: {
          address: location.address,
          areaId: location.area.id
        },
        price: price,
        privacy: tmp$1
      }
    }, undefined, undefined, undefined, (param, param$1) => {
      let createQuietSeller = param.createQuietSeller;
      if (createQuietSeller !== undefined && createQuietSeller.__typename === "QuietSellerCreated") {
        let clientId = createQuietSeller.client.id;
        notifyOnSuccess(undefined);
        addMessage(SystemMessages.Message.make(undefined, "info", "Your Quiet Seller was added to TAN", 5000, undefined, undefined));
        return Next.Router.push(`/my_clients/` + clientId + `?isNew=1`, undefined, undefined, router);
      } else {
        return handleError();
      }
    }, param => handleError(), undefined);
  });
  React.useEffect(() => {
    let match = form.input;
    let area = match.area;
    let address = match.address;
    if (area !== undefined && address.length > 1) {
      form.updateLocation((input, location) => {
        let newrecord = {...input};
        newrecord.location = location;
        return newrecord;
      }, {
        address: address,
        area: area
      });
    }
  }, [
    form.input.address,
    Stdlib_Option.map(form.input.area, area => area.id)
  ]);
  let focusTracker = FocusTracker$1.use();
  let match$2 = focusTracker.focusedField;
  let tmp;
  tmp = match$2 === "Address" ? JsxRuntime.jsx(QuietPropertyTipBoxes.StreetAddress.make, {}) : undefined;
  let match$3 = focusTracker.focusedField;
  let tmp$1;
  tmp$1 = match$3 !== undefined && match$3 !== "Address" ? JsxRuntime.jsx(QuietPropertyTipBoxes.PriceRange.make, {}) : undefined;
  let match$4 = form.input.privacy;
  let tmp$2;
  let exit = 0;
  switch (match$4) {
    case "Normal" :
    case "HideMyName" :
      exit = 1;
      break;
    case "HideProperty" :
      tmp$2 = null;
      break;
  }
  if (exit === 1) {
    tmp$2 = JsxRuntime.jsx(FormV5.FormSection.make, {
      children: JsxRuntime.jsx(CreateQuietSellerForm$Description, {
        form: form
      })
    });
  }
  return JsxRuntime.jsxs("form", {
    children: [
      JsxRuntime.jsx(FormV5.FormSection.make, {
        children: JsxRuntime.jsx(PageUITitle.make, {
          title: "Add your seller quietly",
          subtitle: "Describe the property your client is selling. You'll immediately get a list of TAN agents with buyers looking for similar homes. We'll also email you when any new matching buyers are added."
        })
      }),
      JsxRuntime.jsx(FormV5.FormSection.make, {
        tipbox: tmp,
        children: JsxRuntime.jsx(CreateQuietSellerForm$Location, {
          form: form,
          focusTracker: focusTracker
        })
      }),
      JsxRuntime.jsx(FormV5.FormSection.make, {
        tipbox: tmp$1,
        children: JsxRuntime.jsx(CreateQuietSellerForm$Price, {
          form: form,
          focusTracker: focusTracker
        })
      }),
      JsxRuntime.jsx(FormV5.FormSection.make, {
        children: JsxRuntime.jsx(CreateQuietSellerForm$PropertyAttributes, {
          form: form
        })
      }),
      JsxRuntime.jsx(FormV5.FormSection.make, {
        children: JsxRuntime.jsx(CreateQuietSellerForm$Privacy, {
          form: form
        })
      }),
      tmp$2,
      JsxRuntime.jsx(FormV5.FormSection.make, {
        children: JsxRuntime.jsx(CreateQuietSellerForm$AttachmentSection, {
          form: form
        })
      }),
      JsxRuntime.jsx(FormV5.FormSection.make, {
        children: JsxRuntime.jsx(CreateQuietSellerForm$Client, {
          form: form
        })
      }),
      JsxRuntime.jsx(FormV5.FormSection.make, {
        children: JsxRuntime.jsxs(ViewStack.make, {
          space: Responsive.make("lg", undefined, "xl", undefined, undefined, undefined, undefined),
          alignItems: "baseline",
          justifyContent: "flexEnd",
          flexDirection: "row",
          children: [
            JsxRuntime.jsx(ButtonsV5.LinkButton.make, {
              onClick: param => Next.Router.back(router),
              size: "huge",
              _type: "button",
              children: "Cancel"
            }),
            JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
              disabled: match$1[1],
              size: "large",
              children: "Add seller quietly"
            })
          ]
        })
      })
    ],
    className: MobileInputTextSize.className,
    onSubmit: event => {
      event.preventDefault();
      form.submit();
    }
  });
}

let UIKitStatus;

let PropertyLocation;

let ForSalePropertyPrice;

let ForSalePropertyAttributes;

let Grid;

let Cell;

let ContentBox;

let FormSection;

let make = CreateQuietSellerForm;

exports.messageToString = messageToString;
exports.FieldValidationMessage = FieldValidationMessage;
exports.UIKitStatus = UIKitStatus;
exports.PropertyLocation = PropertyLocation;
exports.ForSalePropertyPrice = ForSalePropertyPrice;
exports.ForSalePropertyAttributes = ForSalePropertyAttributes;
exports.Grid = Grid;
exports.Cell = Cell;
exports.ContentBox = ContentBox;
exports.FormSection = FormSection;
exports.FocusTracker = FocusTracker$1;
exports.Location = Location;
exports.Price = Price;
exports.PropertyAttributes = PropertyAttributes;
exports.Privacy = Privacy;
exports.Description = Description;
exports.Client = Client;
exports.AttachmentSection = AttachmentSection;
exports.initialInput = initialInput;
exports.Mutation = Mutation;
exports.make = make;
/* FocusTracker Not a pure module */
